import StringUtils from "utilities/string-utils";
import SectionRecord from "models/view-models/section-record";
import React, { useEffect, useRef } from "react";
import { XmlChangeNotationConstants } from "constants/xml-change-notation-constants";
import { useLocation } from "react-router-dom";
import SectionDetailContentWithinPanel from "organisms/publication-content/notebook-reference-panel/section-detail-content-within-panel";

interface SectionDetailWithinPanelProps {
    classNames: string[];
    cssBaseClass: string;
    renderContent?: boolean;
    section: SectionRecord;
    sectionLabel: JSX.Element | undefined;
    titleClassName: string;
    onSectionHover: (id: number) => void;
}
const SectionDetailWithinPanel = (props: SectionDetailWithinPanelProps) => {
    const {
        classNames,
        cssBaseClass,
        renderContent = true,
        section,
        sectionLabel,
        titleClassName,
        onSectionHover,
    } = props;

    const isDeleted =
        section.changes === XmlChangeNotationConstants.DELETION ||
        section.tiaChanges === XmlChangeNotationConstants.TIA_DELETION;

    const sectionRef = useRef<HTMLElement>(null);
    const { hash } = useLocation();

    // TODO: Go here to enable autoscrolling to section
    useEffect(() => {
        if (hash.includes(section.externalId)) sectionRef.current?.focus();
    }, [hash, section.externalId]);

    return (
        <section
            onMouseEnter={() => onSectionHover(section.id!)}
            data-section-level={section.type}
            data-section-label={section.nfpaLabel}
            className={StringUtils.joinClassNames(classNames)}
            id={section.externalId}
            ref={sectionRef}
            tabIndex={-1}>
            {renderContent ? (
                <>
                    {isDeleted ? (
                        <></>
                    ) : (
                        <>
                            <SectionDetailContentWithinPanel
                                sectionLabel={sectionLabel}
                                cssBaseClass={cssBaseClass}
                                section={section}
                                titleClassName={titleClassName}
                            />
                        </>
                    )}
                </>
            ) : (
                section.getEmptySections()
            )}
        </section>
    );
};

export default SectionDetailWithinPanel;
